import { Component, OnInit } from '@angular/core';
import { GetList, SetViewStatus } from './store/actions/excel-connector-list.actions';
import { Store, select } from '@ngrx/store';
import { Subscription, Observable } from 'rxjs';
import { BzgModalRef, BzgModalService } from 'bz-genome-angular';
import { SavePendingChangesComponent } from 'app/shared/components/save-pending-changes/save-pending-changes.component';
import { getExcelConnectors, getExcelConnectorViewStatus, getIsLoadingConnectorsList } from 'app/connect/connect-excel/store/selectors/excel-connector-list.selector';
import {
  getCurrentExcelConnector,
  getCurrentExcelConnectorDetailVersion,
  getCurrentExcelConnectorIsLoading,
  getFileNameConnectorDetail,
  getCurrentExcelConnectorIsUploading }
  from './store/selectors/excel-connector-current.selector';
import { EExcelConnectorViewStatus } from 'app/connect/core/excel-connector.enum';
import { GetDetailFromVersion, SetSelectedFileName, SetCurrentConnector, UploadExcelFile, DownloadExcelFile, ResetDetailFromVersion } from './store/actions/excel-connector-current.actions';
import { IAppState } from 'app/IAppState';

@Component({
  selector: 'biz-excel-connector',
  templateUrl: './connect-excel.component.html',
  styleUrls: ['./connect-excel.component.scss']
})
export class ExcelConnectorComponent implements OnInit {
  private modalRef: BzgModalRef;
  private nextConnectorChild: IExcelConnectorChildren;
  private currentConnectorChild: IExcelConnectorChildren;
  private currentDetailVersionSubscription: Subscription;
  private lastActionCancel: boolean;

  public connectors$: Observable<IExcelConnector[]>;
  public selectedConnector$: Observable<IExcelConnector>;
  public selectedDetailVersionConnector$: Observable<IExcelVersionConnector>;
  public detailViewStatus$: Observable<number>;
  public currentExcelConnectorIsLoading$: Observable<boolean>;
  public isLoadingConnectors$: Observable<boolean>;
  public isUploadingExcelFile$: Observable<boolean>;
  public uploadedFile: any;
  public currentDetailVersion: IExcelVersionConnector;
  public selectedConnectorChild: IExcelConnectorChildren;
  public resetInputFile: boolean;


  constructor(private _store: Store<IAppState>, private _modalService: BzgModalService) {
    this.connectors$ = this._store.pipe(select(getExcelConnectors));
    this.selectedConnector$ = this._store.pipe(select(getCurrentExcelConnector));
    this.currentDetailVersionSubscription = this._store.pipe(
      select(getCurrentExcelConnectorDetailVersion))
      .subscribe((currentDetailVersion) => this.currentDetailVersion = currentDetailVersion);
    this.detailViewStatus$ = this._store.pipe(select(getExcelConnectorViewStatus));
    this.currentExcelConnectorIsLoading$ = this._store.pipe(select(getCurrentExcelConnectorIsLoading));
    this.isLoadingConnectors$ = this._store.pipe(select(getIsLoadingConnectorsList));
    this.isUploadingExcelFile$ = this._store.pipe(select(getCurrentExcelConnectorIsUploading));
  }

  ngOnInit() {
    this._store.dispatch(new GetList());
  }

  ngOnDestroy(): void {
    this.currentDetailVersionSubscription.unsubscribe();
    this._store.dispatch(new ResetDetailFromVersion());
  }

  dialogPendingChanges(connector?) {
    this.modalRef = this._modalService.open(SavePendingChangesComponent, {closeOnRouterNavigation: true});
    this.modalRef.afterClosed().subscribe(result => {
      switch (result.action) {
        case 'dontsave':
          this.uploadedFile = null;
          this.resetInputFile = true;
          if (connector) {
            this.changeConnector(connector);
          } else {
            if (this.nextConnectorChild) {
              this.selectedConnectorChild = this.nextConnectorChild;
              this._store.dispatch(new GetDetailFromVersion(this.nextConnectorChild.id));
            } else {
              this._store.dispatch(new GetDetailFromVersion(this.currentConnectorChild.id));
            }
          }
          this.modalRef.close();
          break;
        case 'save':
          this.onSave();
          this.resetInputFile = true;
          if (connector) {
            this.changeConnector(connector);
          } else {
            if (this.nextConnectorChild) {
              this.selectedConnectorChild = this.nextConnectorChild;
              this._store.dispatch(new GetDetailFromVersion(this.nextConnectorChild.id));
            }
          }
          this.modalRef.close();
          break;
        default:
          this.lastActionCancel = true;
          this.resetInputFile = false;
          this.selectedConnectorChild = this.currentConnectorChild;
          this.modalRef.close();
          break;
      }
    });
  }

  applySelectConnector(connector: IExcelConnector) {
    if (this.uploadedFile) {
      this.dialogPendingChanges(connector);
    } else {
      this.resetInputFile = true;
      this.selectedConnectorChild = undefined;
      this.changeConnector(connector);
    }
  }

  onVersionChanged(child: IExcelConnectorChildren) {
    if (this.uploadedFile && !this.lastActionCancel) {
      this.nextConnectorChild = child;
      this.dialogPendingChanges();
    } else {
      this.currentConnectorChild = child;
      this.nextConnectorChild = null;
      this._store.dispatch(new GetDetailFromVersion(child.id));
      this.lastActionCancel = false;
    }
  }

  onUploadFile(file: any) {
    this.resetInputFile = false;
    this.uploadedFile = file;
    this._store.dispatch(new SetSelectedFileName(file.name));
  }

  onSave() {
    if (this.uploadedFile) {
      this._store.dispatch(new UploadExcelFile(this.uploadedFile));
      this.uploadedFile = null;
    }
  }

  onDownload(file) {
    if (file && file.id) {
      this._store.dispatch(new DownloadExcelFile(file.id));
    }
  }

  onCancel() {
    this.uploadedFile = null;
    this.resetInputFile = true;
    if (this.nextConnectorChild) {
      this.selectedConnectorChild = this.nextConnectorChild;
      this._store.dispatch(new GetDetailFromVersion(this.nextConnectorChild.id));
    } else {
      this._store.dispatch(new GetDetailFromVersion(this.currentConnectorChild.id));
    }
  }

  changeConnector(connector) {
    this._store.dispatch(new SetSelectedFileName(''));
    this._store.dispatch(new SetCurrentConnector(connector));
    this._store.dispatch(new SetViewStatus(EExcelConnectorViewStatus.EDIT));
  }

}
